// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CreateOrEditIssue_Wrapper__3CAcv","Name":"CreateOrEditIssue_Name__3O59_","SectionHeader":"CreateOrEditIssue_SectionHeader__278H2"};